import { useEffect, useState } from "react";
import { api, apiError, fmtDate } from "../lib/api";
import { toast } from "sonner";
import { Database, Download, RefreshCw, Package2 } from "lucide-react";

export default function BackupsPage() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busy, setBusy] = useState(false);

    async function load() {
        try { const { data } = await api.get("/admin/backups"); setRows(data); }
        catch (e) { toast.error(apiError(e)); }
        finally { setLoading(false); }
    }
    useEffect(() => { load(); }, []);

    async function runNow() {
        setBusy(true);
        try {
            const { data } = await api.post("/admin/backup-now");
            toast.success(`Backup saved · ${data.backup}`);
            load();
        } catch (e) { toast.error(apiError(e)); }
        finally { setBusy(false); }
    }

    async function downloadZip() {
        try {
            const backend = process.env.REACT_APP_BACKEND_URL || "";
            const token = localStorage.getItem("token");
            const res = await fetch(`${backend}/api/admin/export.zip`, { headers: { Authorization: `Bearer ${token}` } });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const blob = await res.blob();
            const cd = res.headers.get("content-disposition") || "";
            const m = cd.match(/filename=([^;]+)/);
            const filename = m ? m[1].trim() : "flexworx-export.zip";
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url; a.download = filename; a.click();
            URL.revokeObjectURL(url);
            toast.success("Export downloaded");
        } catch (e) { toast.error(String(e.message || e)); }
    }

    return (
        <div className="mx-auto max-w-4xl px-4 sm:px-6 py-6 sm:py-10">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
                <div>
                    <div className="text-xs font-medium uppercase tracking-wider text-gray-500">HO Admin</div>
                    <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#1E3355] mt-1 flex items-center gap-2"><Database className="w-6 h-6" /> Backups & export</h1>
                    <p className="text-sm text-gray-500 mt-1">Daily automated backup at ~02:00 IST · last 14 kept.</p>
                </div>
                <div className="flex gap-2">
                    <button onClick={downloadZip} className="inline-flex items-center gap-1.5 rounded-md border border-[#1E3355] text-[#1E3355] hover:bg-[#F4F6F9] px-4 py-2 text-sm font-semibold" data-testid="backups-export-zip"><Package2 className="w-4 h-4" /> Download full ZIP export</button>
                    <button onClick={runNow} disabled={busy} className="inline-flex items-center gap-1.5 bg-[#1E3355] hover:bg-[#15243C] text-white text-sm font-semibold px-4 py-2 rounded-md disabled:opacity-60" data-testid="backups-run-now"><RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} /> Backup now</button>
                </div>
            </div>

            <div className="mt-6 rounded-xl bg-white border border-gray-100 fx-shadow-card overflow-hidden">
                {loading ? <div className="p-10 text-center text-sm text-gray-500">Loading…</div> :
                rows.length === 0 ? <div className="p-10 text-center text-sm text-gray-500" data-testid="backups-empty">No backups yet. Click Backup now to create the first one.</div> :
                <table className="w-full text-sm" data-testid="backups-table">
                    <thead className="bg-[#F4F6F9] text-left text-[11px] font-semibold uppercase tracking-wider text-gray-500">
                        <tr><th className="px-4 py-2">Backup</th><th className="px-4 py-2">Created</th><th className="px-4 py-2">Files</th><th className="px-4 py-2 text-right">Size</th></tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {rows.map((r) => (
                            <tr key={r.name} data-testid={`backup-row-${r.name}`}>
                                <td className="px-4 py-2 font-mono text-xs">{r.name}</td>
                                <td className="px-4 py-2 text-gray-600 text-xs">{r.created_at.slice(0, 16).replace("T", " ")}</td>
                                <td className="px-4 py-2 text-xs">{r.files}</td>
                                <td className="px-4 py-2 text-right text-xs tabular-nums">{(r.size_bytes / 1024).toFixed(1)} KB</td>
                            </tr>
                        ))}
                    </tbody>
                </table>}
            </div>
        </div>
    );
}
